import React from "react";

// Danger Button - Destructive actions
export const DangerButton = ({
  children,
  onClick,
  disabled = false,
  className = "",
  type = "button",
  loading,
  icon: Icon,
  ...props
}) => {
  // Filter out props that shouldn't go to the DOM
  const { icon: _, ...buttonProps } = props;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        bg-red-500 text-white px-3 py-2 max-lg:min-h-11 rounded-md text-sm font-semibold
        hover:bg-red-600
        focus:outline-none focus:ring-2 focus:ring-red-300
        transition-colors duration-200
        inline-flex items-center justify-center space-x-2
        disabled:opacity-50 disabled:cursor-not-allowed
        ${loading ? "cursor-not-allowed" : ""}
        ${className}
      `}
      {...buttonProps}
    >
      {loading ? (
        <>
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Loading...
        </>
      ) : (
        <>
          {Icon && <Icon className="w-4 h-4" />}
          {children}
        </>
      )}
    </button>
  );
};

export default DangerButton;
